<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="filters.ledger.operationType" :options="operationTypes" placeholder="placeholder.operationType" style="width: 10%" @change="refresh"/>
        <vxe-select v-model="filters.owner.id" :options="owners" placeholder="placeholder.owner" style="width: 15%" @change="refresh"/>
        <vxe-input v-model="filters.item.no" placeholder="placeholder.itemNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.lot.no" placeholder="placeholder.lotNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.logicalStore.name" placeholder="business.label.logicalStore" style="width: 10%" @clear="onLogicalStoreChange([])" @click="onLogicalStoreSelect"/>
        <vxe-input v-model="filters.storageRoom.name" placeholder="placeholder.storageRoom" style="width: 10%" @clear="onStorageRoomChange([])" @click="onStorageRoomSelect"/>
        <vxe-input v-model="filters.zone.name" placeholder="placeholder.zone" style="width: 10%" @clear="onZoneChange([])" @click="onZoneSelect"/>
        <vxe-input v-model="filters.location.no" placeholder="placeholder.location" style="width: 10%" @clear="onLocationChange([])" @click="onLocationSelect"/>
        <vxe-input v-model="filters.container.no" placeholder="placeholder.containerNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :height="800" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="ledger.operationType" title="business.label.operationType" width="70"/>
        <vxe-column field="ledger.addBy" title="business.label.operator" width="70"/>
        <vxe-column field="ledger.addTime" title="business.label.addTime" width="170"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="100"/>
        <vxe-column field="batch.no" title="business.label.batch" width="100"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
        <vxe-column field="location.no" title="business.label.location" width="120"/>
        <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column field="ledger.balance" title="business.label.balance" width="60"/>
        <vxe-column field="ledger.grossBalance" title="business.label.grossBalance" width="60"/>
        <vxe-column field="ledger.quantity" title="business.label.quantity" width="60"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="customer.name" title="business.label.customer" width="120"/>
        <vxe-column field="zone.name" title="business.label.zone" width="100"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="100"/>
      </vxe-table>
    </vxe-card>
    <field-modal ref="logicalStoreModal" :no="'LOGICAL_STORE'" :show-value="false" :title="$t('business.label.logicalStore')" @change="onLogicalStoreChange"/>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <zone-modal ref="zoneModal" @change="onZoneChange"/>
    <location-modal ref="locationModal" @change="onLocationChange"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Location } from '@/api/dto/common/Location'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import FieldModal from '@/views/modal/FieldModal.vue'
import { getEnums, getOptions } from '@/utils/util'

export default {
  components: { FieldModal, StorageRoomModal, ZoneModal, LocationModal },
  data() {
    return {
      loading: false,
      filters: new InventoryFactoryView(),
      data: [],
      owners: [],
      operationTypes: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
    })
  },
  methods: {
    onLogicalStoreSelect() {
      this.$refs.logicalStoreModal.open({ available: true })
    },
    onLogicalStoreChange(values) {
      this.filters.logicalStore = new Dictionary(values[0])
      this.refresh()
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(values) {
      this.filters.storageRoom = new StorageRoom(values[0])
      this.refresh()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.filters.storageRoom.id })
    },
    onZoneChange(values) {
      this.filters.zone = new Zone(values[0])
      this.refresh()
    },
    onLocationSelect() {
      this.$refs.locationModal.open({ 'storageRoom.id': this.filters.storageRoom.id, 'zone.id': this.filters.zone.id })
    },
    onLocationChange(values) {
      this.filters.location = new Location(values[0])
      this.refresh()
    },
    fetch() {
      if (!this.filters.item.no && !this.filters.lot.no && !this.filters.location.no && !this.filters.container.no) {
        return this.$message.warning('商品、批号、货位、容器不可全部为空')
      }
      this.loading = true
      const args = {
        operationType: this.filters.ledger.operationType,
        'owner.id': this.filters.owner.id,
        'item.no': this.filters.item.no,
        'lot.no': this.filters.lot.no,
        'logicalStore.id': this.filters.logicalStore.id,
        'storageRoom.id': this.filters.storageRoom.id,
        'zone.id': this.filters.zone.id,
        'location.id': this.filters.location.id,
        'container.no': this.filters.container.no
      }
      findAll('ledgerFactory', args, 1, 50).then(res => {
        if (res.success) {
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.data = []
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>